export default function(realDistance, perMeter) {
  return Math.ceil((realDistance * perMeter) / 100)
}



// WEBPACK FOOTER //
// ./src/utils/perMeterCalc.js